import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';

import NewsArticle from '../../../../src/models/NewsArticle';
import NewsConfiguration from '../../../../src/models/NewsConfiguration';
import NewsModalAccordionItem from '../views/NewsModalAccordionItem';
import Cookies from 'universal-cookie';


type NewsModalMobilePageProps = {
    configuration: NewsConfiguration,
    articles: NewsArticle[]
}

type NewsModalMobilePageState = {
    showModal: boolean,
    activeTab: number,
}

export default class NewsModalMobilePage extends Component<NewsModalMobilePageProps, NewsModalMobilePageState> {

    constructor(props: NewsModalMobilePageProps) {
        super(props);
        this.activatePanel = this.activatePanel.bind(this);
        this.blockBody();
        this.state = {
            showModal: true,
            activeTab: 0,
        };
    }

    public closeModal() {
        this.unblockBody();
        const cookies = new Cookies();
        let seenNews = cookies.get('seenNewsModal') ?? [];
        seenNews = [
          ...seenNews,
          ...this.props.configuration.articles.map(a => a.nodeGUID)
        ];

        cookies.set('seenNewsModal', seenNews, { path: '/', maxAge: 31556926, secure: true });
        this.setState({
            showModal: false,
        })
    }

    public blockBody(): void {
        document.body.style.position = 'fixed';
        document.body.style.top = '0px';
        document.body.style.left = '0px';
        document.body.style.right = '0px';
    }

    public unblockBody(): void {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
    }

    public activatePanel(index: number, event: any) {
        if (index === this.state.activeTab) {
            index = (index + 1) % this.props.articles.length;
        }
        this.setState({
            showModal: this.state.showModal,
            activeTab: index,
        });
    }

    public render() {
        return (
            <>
                <Modal
                    show={this.state.showModal}
                    onHide={() => this.closeModal()}
                    keyboard={false}
                    centered={true}
                    backdrop="static"
                    dialogClassName="important-news-modal-mobile"
                >
                    <Modal.Body bsPrefix="modal-body p-0 mh-100 bg-ecru">
                        <div className="d-flex flex-column h-100">
                            {
                            this.props.articles.map((article: NewsArticle, index: number) => {
                                return (
                                    <NewsModalAccordionItem onClick={this.activatePanel.bind(null, index)} configuration={this.props.configuration} article={article} index={index} key={index} active={this.state.activeTab === index}></NewsModalAccordionItem>
                                )
                            })
                            }
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-blue text-black w-100" onClick={() => {this.closeModal();}}>{this.props.configuration.continueToSiteText}</button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}